import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions,
  Select,
  MenuItem,
  TextField,
} from "@mui/material";
import axios from "axios";
import { observer } from "mobx-react";
import React, { CSSProperties, useEffect, useState } from "react";
import { ReactNode } from "react";
import { Button } from "react-bootstrap";
import { controlleStore } from "../../Stores/controllerStore";
import {
  Controller,
  ControllerCondition,
  ControllerType,
} from "../../Model/controller";
import XboxLogo from "../../Assets/Icons/xbox.png";
import PlaystationLogo from "../../Assets/Icons/playstation.png";
import PoolStickLogo from "../../Assets/Icons/gambling.png";

const _NewControllerDialog: React.FC<{ child: ReactNode }> = ({ child }) => {
  const [open, setOpen] = useState(false);
  const [nickname, setNickname] = useState("");
  const [uuid, setUUID] = useState("");
  const [type, setType] = useState<ControllerType>(ControllerType.PLAYSTATION);
  const [controllerCondition, setControllerCondition] =
    useState<ControllerCondition>(ControllerCondition.GOOD);
  const [s, a] = useState("");
  const handleClose = () => {
    setOpen(false);
  };

  const addController = () => {
    controlleStore.add({
      barcodeId: "Default Barcode",
      controllerCondition: controllerCondition,
      controllerType: type,
      nickname: nickname,
      registrationDate: new Date(),
    } as Controller);
  };
  return (
    <React.Fragment>
      <Button onClick={() => setOpen(true)}>New +</Button>
      <Dialog
        open={open}
        onClose={handleClose}
        aria-labelledby="draggable-dialog-title"
        style={{ padding: 40 }}
      >
        <div
          style={{
            display: "flex",
            flexFlow: "column",
            textAlign: "center",
            padding: "20px",
            width: "400px",
          }}
        >
          <h3>Controller</h3>
          <ControllerTypeSelector
            onSelectChange={(c) => {
              console.log(c + " Selected!");
              setType(c);
            }}
          />
          <ControllerConditionSelector
            onSelectChange={(c) => {
              console.log(c + " Selected!");
              setControllerCondition(c);
            }}
          />

          <TextField
            id="outlined-basic"
            label="Name of the controller (in-store nickname/fun-name)"
            variant="outlined"
            value={nickname}
            onChange={(e) => setNickname(e.target.value)}
          />
          <TextField
            id="outlined-basic"
            label="Barcode ID"
            variant="outlined"
          />

          <Button variant="primary" onClick={addController}>
            Add Controller
          </Button>
          <Button variant="danger">Cancel and Close</Button>
        </div>
      </Dialog>
    </React.Fragment>
  );
};

const ControllerTypeSelector: React.FC<{
  onSelectChange: (selected: ControllerType) => void;
}> = ({ onSelectChange }) => {
  const [type, setType] = useState<ControllerType>(ControllerType.PLAYSTATION);

  const itemStyle = {
    display: "flex",
    flexFlow: "row",
  } as CSSProperties;

  useEffect(() => {
    onSelectChange(type);
  }, [type]);
  return (
    <Select
      labelId="demo-simple-select-filled-label"
      id="demo-simple-select-filled"
      value={type}
      onChange={(e) => setType(e.target.value as ControllerType)}
    >
      <MenuItem value={ControllerType.PLAYSTATION} style={itemStyle}>
        <img src={PlaystationLogo} height={30} /> <label>PlayStation 5</label>
      </MenuItem>
      <MenuItem value={ControllerType.XBOX_SERIES} style={itemStyle}>
        <img src={XboxLogo} height={30} /> <label>Xbox Series S|X</label>
      </MenuItem>
      <MenuItem value={ControllerType.POOL_STICK} style={itemStyle}>
        <img src={PoolStickLogo} height={30} /> <label>Pool Stick</label>
      </MenuItem>
    </Select>
  );
};

const ControllerConditionSelector: React.FC<{
  onSelectChange: (selected: ControllerCondition) => void;
}> = ({ onSelectChange }) => {
  const [condition, setCondition] = useState<ControllerCondition>(
    ControllerCondition.EXCELLENT
  );

  const itemStyle = {
    display: "flex",
    flexFlow: "row",
  } as CSSProperties;

  useEffect(() => {
    onSelectChange(condition);
  }, [condition]);
  return (
    <Select
      labelId="demo-simple-select-filled-label"
      id="demo-simple-select-filled"
      value={condition}
      onChange={(e) => setCondition(e.target.value as ControllerCondition)}
    >
      <MenuItem value={ControllerCondition.EXCELLENT} style={itemStyle}>
        <label>Brand New. Excellent</label>
      </MenuItem>
      <MenuItem value={ControllerCondition.GOOD} style={itemStyle}>
        <label>Good condition</label>
      </MenuItem>
      <MenuItem value={ControllerCondition.PLAYABLE} style={itemStyle}>
        <label>Not Damaged. Playable</label>
      </MenuItem>
      <MenuItem value={ControllerCondition.POOR} style={itemStyle}>
        <label>Almost unplayable</label>
      </MenuItem>
      <MenuItem value={ControllerCondition.DAMAGED} style={itemStyle}>
        <label>Damaged. Unplayable</label>
      </MenuItem>
    </Select>
  );
};

const NewControllerDialog = observer(_NewControllerDialog);

export default NewControllerDialog;
